// config.js
const API_URL = 'https://odyssey.net.vn/api/api';

export default API_URL;
